(function ($) {
    if (!window.JQUERY_IS_ANIMATING) {
        window.JQUERY_IS_ANIMATING = false;
    }

    let activeAnimations = 0;

    function updateGlobalFlag() {
        window.JQUERY_IS_ANIMATING = activeAnimations > 0;
    }

    // ---- Patch fx.start ----
    const originalFxStart = $.fx.start;
    $.fx.start = function () {
        activeAnimations++;
        updateGlobalFlag();
        return originalFxStart.apply(this, arguments);
    };

    // ---- Patch fx.stop ----
    const originalFxStop = $.fx.stop;
    $.fx.stop = function () {
        if (activeAnimations > 0) {
            activeAnimations--;
        }
        updateGlobalFlag();
        return originalFxStop.apply(this, arguments);
    };
})(jQuery);